import { Inject, Injectable, Optional } from '@angular/core';

import { distinctUntilChanged } from 'rxjs';
import { RootState } from '@store/index';

import { select, Store } from '@ngrx/store';
import { PageMetasActions, PageMetasSelectors } from '@store/page-metas';

import { TranslateService } from '@ngx-translate/core';

import { IS_SERVER, LanguagesEnum, TLanguage } from '@core/config';
import { Request } from 'express';
import { REQUEST } from '../../../express.tokens';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  static selectedLanguage: TLanguage = 'EN';

  static isSelectedLanguage(lang: string = null): boolean | null {
    if (!lang) {
      return null;
    }

    return lang.toUpperCase() === this.selectedLanguage;
  }

  constructor(
    @Inject(IS_SERVER) private isServer: boolean,
    @Inject(REQUEST) @Optional() private request: Request,
    private translateService: TranslateService,
    private store: Store<RootState>
  ) {
    this.subscribeToLanguage();
    this.translateService.use(this.selectedLanguage);
  }

  public init(serverLanguage: TLanguage = null): void {
    this.useLanguage(serverLanguage || this.selectedLanguage);
  }

  get selectedLanguage(): TLanguage | null {
    return LanguageService.selectedLanguage;
  }

  set selectedLanguage(language: string | TLanguage) {
    LanguageService.selectedLanguage = language?.toUpperCase() as TLanguage;
  }

  public getLanguage(): TLanguage {
 
   
   let lang =    (this.isServer ? this.getLanguageServer() : this.getLanguageBrowser()) || LanguagesEnum.EN;
 
   return lang;
  }

  public useLanguage(language: TLanguage | string, dispatch = true): void {
    const hasChanged = language?.toUpperCase() !== this.selectedLanguage?.toUpperCase();

    this.selectedLanguage = language?.toUpperCase() as TLanguage;
    this.translateService.use(this.selectedLanguage);

    if (!dispatch) {
      return;
    }

    this.store.dispatch(PageMetasActions.setLanguage({ language: this.selectedLanguage, fetchNav: hasChanged }));
  }

  private subscribeToLanguage(): void {
    this.store.pipe(select(PageMetasSelectors.selectCurrentLanguage()), distinctUntilChanged()).subscribe(lang => {
      this.useLanguage(lang, false);
    });
  }

  private getLanguageBrowser(): TLanguage {
    const browserLang = this.translateService.getBrowserLang()?.toUpperCase();

    return  LanguagesEnum.EN;
  }

  private getLanguageServer(): TLanguage {
    const preferredLanguage = this.getPreferredLanguage()?.toUpperCase();
    
    return  LanguagesEnum.EN;
  }

  private getPreferredLanguage(headers = this.request?.headers): string {
    try {
      return headers['accept-language'].split('-')[0]?.toUpperCase();
    } catch (e) {
      return null;
    }
  }
}
